import almoxarifado from "@/router/almoxarifado.ts";
import compras from "@/router/compras.ts";
import configuracoes from "@/router/configuracoes.ts";
import contabilidade from "@/router/contabilidade.ts";
import controladoria from "@/router/controladoria.ts";
import crm from "@/router/crm.ts";
import dashboard from "@/router/dashboards.ts";
import eCommerce from "@/router/e-commerce.ts";
import equipe from "@/router/equipe.ts";
import estoque from "@/router/estoque.ts";
import faturamento from "@/router/faturamento.ts";
import financeiro from "@/router/financeiro.ts";
import home from "@/router/home.ts";
import industrializacao from "@/router/industrializacao.ts";
import logistica from "@/router/logistica.ts";
import pcp from "@/router/pcp.ts";
import produtividade from "@/router/produtividade.ts";
import recebimento from "@/router/recebimento.ts";
import rh from "@/router/rh.ts";
import site from "@/router/site.ts";
import sobre from "@/router/sobre.ts";
import vendas from "@/router/vendas.ts";

export default [
  {
    component: () => import("@/layout/AppLayout.vue"),
    meta: { requiresAuth: true, requiresEmitente: true },
    children: [
      ...almoxarifado,
      ...compras,
      ...configuracoes,
      ...contabilidade,
      ...controladoria,
      ...crm,
      ...dashboard,
      ...eCommerce,
      ...equipe,
      ...estoque,
      ...faturamento,
      ...financeiro,
      ...home,
      ...industrializacao,
      ...logistica,
      ...pcp,
      ...produtividade,
      ...recebimento,
      ...rh,
      ...site,
      ...sobre,
      ...vendas,
    ],
  },
];
